import { useStaticQuery, graphql } from "gatsby"

export const useWebform = () => {
  const webform = useStaticQuery(
    graphql`
      query {
        webformWebform(drupal_internal__id: { eq: "contact" }) {
          drupal_internal__id
          elements {
            name
            type
            attributes {
              name
              value
            }
            options {
              label
              value
            }
          }
        }
      }
    `
  )
  return webform
}
